function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgChrome = function SvgChrome(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    "data-name": "\\u56FE\\u5C42 1",
    viewBox: "0 0 1024 1024"
  }, props), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "chrome_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h1024v1024H0z",
    style: {
      fill: "none"
    }
  }))), /*#__PURE__*/React.createElement("path", {
    d: "m119.55 344.28 168.28 291.46c54.32 98.42 166.49 149.9 276.52 126.89l-100.1 173.4C251.09 912.31 85.33 731.53 85.33 512.01c0-59.56 12.2-116.22 34.22-167.72Zm783.62-2.94a426.674 426.674 0 0 1 35.5 170.67c0 218.37-164.05 398.42-375.64 423.68l168.45-291.84C754.69 605.36 768 560.22 768 512.01a255.163 255.163 0 0 0-65.19-170.67h200.36Zm-391.17 0c94.25 0 170.67 76.41 170.67 170.67S606.26 682.68 512 682.68s-170.67-76.41-170.67-170.67S417.74 341.34 512 341.34Zm0-256c134.31-.07 260.8 63.18 341.33 170.67H512c-110.58-.03-208.69 70.95-243.24 176l-100.1-173.35C249.06 149.61 376.51 85.27 512 85.35Z",
    style: {
      clipPath: "url(#chrome_svg__a)"
    }
  }));
};
export default SvgChrome;